import { intersect, partial, struct } from 'io-ts/Decoder';

import { Id as OrganizationId } from '../../../../organization/Id';
import { Id as MaterialId } from '../../../../whole-house/material/Id';

export const Request = intersect(
	struct({
		organizationId: OrganizationId,
	})
)(
	partial({
		materialId: MaterialId,
	})
);
